import { render, staticRenderFns } from "./PmauConfiguracao.vue?vue&type=template&id=8fac9f22&"
import script from "./PmauConfiguracao.vue?vue&type=script&lang=js&"
export * from "./PmauConfiguracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports